const state = { 
    rooms: [],
};

const getters = {
    getEveryoneHasARoom: (state, getters) => {
        // if no rooms exist then cannot be true
        if (state.rooms == null || state.rooms.length == 0) {
            return false;
        }

        const totalPassengers = getters.getPassengersToRoom;
        const hotels = getters.getSelectedHotels;
        const sumReducer = (accumulator, currentValue) => accumulator + currentValue;

        for(let i = 0; i < hotels.length; i++) {
            const rooms = state.rooms.filter((r) => { return r.productId == hotels[i].productId });

            // no rooms for a particular hotel - then return false
            if (rooms == null || rooms.length == 0) {
                return false;
            }
            
            // get the number of passengers in all this hotels rooms
            const passengersInHotel = rooms.flatMap(r => r.passengersInRoom).reduce(sumReducer);
            
            // if not all passengers are roomed for this hotel - then return false
            if (passengersInHotel != totalPassengers) {
                return false;
            }
        }

        // we made it to the end, everyone has a room in all hotels
        return true;
    }, 
    getRoomById: (state) => (productId, elementId) => {
        return state.rooms.find(room => room.productId == productId && room.elementId == elementId);
    },
    getHotelRoomTypes(state, getters) { 
        let hotels = getters.getSelectedHotels;
        let hotelRoomTypes = [];
          
        hotels.forEach((hotel) => {
            let hotelRooms = { 
                productId: hotel.productId, 
                title: hotel.title, 
                rooms: [],
            };
            
            hotel.tariffs.forEach((tariff) => {
              let room = hotelRooms.rooms.find((room) => { return room.elementId == tariff.elementId; });
              
              if (room == null) {
                hotelRooms.rooms.push({
                  elementId: tariff.elementId,
                  element: tariff.element,
                  grades: [ 
                    { 
                        gradeId: tariff.gradeId,
                        grade: tariff.grade,
                    }
                  ],
                  min: tariff.minOccupancy,
                  max: tariff.maxOccupancy
                });
              } else {
                  room.grades.push({ gradeId: tariff.gradeId, grade: tariff.grade });
              }
            });

            // push the rooming information into our array
            hotelRoomTypes.push(hotelRooms);
        });
          
        return hotelRoomTypes;
    }
};

const mutations = { 
    addHotelRoom(state, payload) {
        let roomIndex = state.rooms.findIndex((room) => { 
            return room.productId == payload.productId && room.elementId == payload.elementId
        });

        if (roomIndex != -1) {
            // room exists (update)
            let room = state.rooms[roomIndex];
            room.passengersInRoom.push(payload.numberOfPassengers);
            state.rooms.splice(roomIndex, 1, room);
        } else if (roomIndex == -1) {
            // room does not exist (add)
            state.rooms.push({ 
                productId: payload.productId,
                elementId: payload.elementId,
                gradeId: payload.gradeId,
                passengersInRoom: [ payload.numberOfPassengers ]
            });
        }
    },
    removeHotelRoom(state, payload) {
        let roomIndex = state.rooms.findIndex((room) => { 
            return room.productId == payload.productId && room.elementId == payload.elementId
        });

        if (roomIndex != -1) {
            let room = state.rooms[roomIndex];
            room.passengersInRoom.pop();
            if (room.passengersInRoom.length == 0) {
                // room exists but no more passengers in this room type (remove)
                state.rooms.splice(roomIndex, 1);
            } else {
                state.rooms.splice(roomIndex, 1, room);
            }
        } 
    },
    setHotelGrade(state, payload) {
        let index = state.rooms.find((room) => {
            return room.productId == payload.productId && room.elementId == payload.elementId 
        });

        state.rooms.splice(index, 1, payload);
    },
    clearHotelRoom(state, payload) {
        let roomIndex = state.rooms.findIndex((room) => { 
            return room.productId == payload.productId && room.elementId == payload.elementId
        });
        state.rooms.splice(roomIndex, 1);
    },
    resetRooms(state) {
        state.rooms = [];
    }
}

const actions = { 
    addHotelRoom({ commit, }, payload) {
        commit('addHotelRoom', payload);
    },
    removeHotelRoom({ commit }, payload) {
        commit('removeHotelRoom', payload);
    },
    setHotelGrade({ commit, state }, payload) {
        let room = state.rooms.find((r) => { 
            return r.productId == payload.productId && r.elementId == payload.elementId 
        });
        
        // the grade cannot be set if a room doesn't exist for the hotel / element
        if (room) {
            room.gradeId = payload.gradeId;
            commit('setHotelGrade', room);
        }
    },
    trimRooms({ commit, state }, payload) {
        // find rooms for hotels that are no longer in use
        const unusedRooms = state.rooms.filter((room) => { return room.productId == payload });

        // clear each hotel room from our array
        unusedRooms.forEach((room) => {
            commit('clearHotelRoom', { productId: room.productId, elementId: room.elementId });
        })
    },
    resetRooms({ commit }) {
        commit('resetRooms');
    }
}

export default { 
    state, 
    getters,
    mutations,
    actions
};